export default __webpack_public_path__ + "static/media/rehansiby.6f488ffc.jpg";